import { DynamicPriceQuizQuestions, DynamicPriceQuizResults, FlowUserInputs } from 'features/dynamic-tariff/components/quiz/types'

/**
 * Calculate the score and return the corresponding result
 * @param {FlowUserInputs<DynamicPriceQuizQuestions>} inputs
 * @returns {DynamicPriceQuizResults}
 */
export const calculateScoreForResult = (inputs: FlowUserInputs<DynamicPriceQuizQuestions>): DynamicPriceQuizResults => {
  const { smartHome, solarPanelsOrHomeBattery, electricVehicle } = inputs

  // INTERESTING CASES
  if (smartHome && solarPanelsOrHomeBattery && electricVehicle) return DynamicPriceQuizResults.INTERESTING
  if (electricVehicle && smartHome) return DynamicPriceQuizResults.INTERESTING
  if (solarPanelsOrHomeBattery && smartHome) return DynamicPriceQuizResults.INTERESTING

  // CONSIDERABLE CASES
  if (solarPanelsOrHomeBattery && electricVehicle) return DynamicPriceQuizResults.CONSIDERABLE
  if (electricVehicle || solarPanelsOrHomeBattery || smartHome) return DynamicPriceQuizResults.CONSIDERABLE

  // Otherwise NOT INTERESTING
  return DynamicPriceQuizResults.NOT_INTERESTING
}
